import * as ExcelJS from 'exceljs';
import { StrHlp } from 'src/lib/fliko/helpers/string.helper';
import { ToString } from 'src/lib/fliko/helpers/toString.helper';
import { LocLabelModifier } from '../components/clickable-row-table/models/data-table-config.models';
import { ExcelFile, ExcelFileFactory } from '../factories/excel-file.factory';
import { LocalizationHelper } from '../helpers/localization.helper';
import { note, style, width } from '../helpers/table.constants';
import { LocalizationService } from '../services/localization.service';
import { NoteVM } from './notes.view-model';

export interface GenericNoteExportData {
  noteNo: number;
  date: string;
  author: string;
  title: string;
  content: string;
}

export namespace NoteExportHlp {
  export function createRow<T>(vm: NoteVM<T>, index: number, ls: LocalizationService): GenericNoteExportData {
    const lh = new LocalizationHelper(ls);
    return {
      date: lh.localizeDate(vm.note.lastUpdate, 'dShort'),
      noteNo: index + 1,
      author: ToString.fullName(vm.user),
      title: vm.note.title,
      content: StrHlp.mergeWhitespace(vm.note.description).trim()
    };
  }

  /**
   * Adds border between context, expand row width to fit notes' content
   * @param eg
   * @param sheet
   * @param indexColumns
   * @param contentColumns
   */
  export function format(eg: ExcelFileFactory, sheet: ExcelJS.Worksheet, indexColumns: string[], contentColumns: string[]) {
    for (let i = 2; i <= sheet.rowCount; i++) {
      for (const col of indexColumns) {
        if (sheet.getCell(col + i).value == 1) {
          eg.setStyle(sheet, i, 0, { border: { top: { style: 'thin' } } }, true);
          break;
        }
      }
      eg.expandRow(sheet, i, ...contentColumns);
    }
    for (const col of contentColumns) {
      eg.setStyle(sheet, 1, col, { alignment: { horizontal: 'center' } }, true);
    }
  }
}
const s: Partial<ExcelJS.Style> = { ...style, border: { left: { style: 'thin' } } };
// prettier-ignore
export const genericNoteTableColumns: ExcelFile.Column[] = [
  { header: { key: 'label.noteNo'                                   }, key: 'noteNo',   width: width(80),   style: s    },
  { header: { key: 'label.noteAuthor'                               }, key: 'author',   width: width(200),  style       },
  { header: { key: 'label.date',      modifier: LocLabelModifier.CAP }, key: 'date',     width: width(130),  style       },
  { header: { key: 'form.title'                                     }, key: 'title',    width: width(200),  style       },
  { header: { key: 'form.content'                                   }, key: 'content',  width: width(1000), style: note }
];
